import { Image } from '@starsoft/common/components';
import { SettingsService } from '@starsoft/common/services/SettingsService';
import { AutocompleteSelectorOptionWithImageProps } from './props';
import styles from './styles.module.scss';

/**
 * Component that renders a single coin option in the autocomplete selector
 * Displays coin details including icon, symbol and name
 *
 * @param {Object} props - Component props
 * @param {Coin} props.option - The coin data to display
 * @param {boolean} props.selected - Whether this option is currently selected
 * @param {Function} props.handleSelect - Callback function when option is selected
 * @param {boolean} props.isContainerColor - Whether to use container background color
 * @returns {JSX.Element} Coin option component with icon and details
 */
export function AutocompleteSelectorOptionCoinWithImage({
  option,
  selected,
  handleSelect,
  isContainerColor,
}: AutocompleteSelectorOptionWithImageProps) {
  /**
   * Handles clicking the option
   * Calls the handleSelect callback with the coin option
   */
  function handleClick() {
    handleSelect(option);
  }

  return (
    <div
      className={`${styles.option} ${selected ? styles['option--selected'] : ''} ${isContainerColor ? styles['option--container-color'] : ''}`}
      onClick={handleClick}
    >
      <Image
        alt={`icon-${option?.name}`}
        format="square"
        width={32}
        height={32}
        className={styles.option__image}
        src={`${SettingsService.env.S3_BUCKET_BASE_URL}/coins/rounded/${option.image}`}
        secondarySkeleton
      />
      <div className={styles.option__column}>
        <p className={styles.option__symbol}>{option.code}</p>
        <p className={styles.option__name}>{option.name}</p>
      </div>
    </div>
  );
}
